import { ReactElement, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { Dropdown } from 'components/v2/Dropdown'
import { StyledLink } from 'components/v2/Link'
import List from 'components/v2/List'
import { ArrowRightIcon } from '@10xLabs/react-web/components/Icons/ArrowRight'
import { SeasonEventStatus } from 'features/SeasonEvents/components/Status'
import { seasonTypeMessages } from 'features/SeasonEvents/components/SeasonType/messages'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'
import { GTSeasonEvent } from 'gql/types.generated'
import { SeasonEventsActions } from './Actions'
import { TimeframesModal } from './TimeframesModal'

const SecondaryInfo = styled.div<TSFixMe>`
  font-size: 13px;
  color: #9999bd;
  white-space: nowrap;
`

const Timeframe = styled.div<TSFixMe>`
  display: flex;
  align-items: center;

  svg {
    margin: 0 10px;
  }
`

export const SeasonEventsList = ({ seasonEvents = [] }: { seasonEvents: GTSeasonEvent[] }): ReactElement => {
  const intl = useIntl()
  const login = useLogin()

  const [isOpenTimeframesModal, setOpenTimeframesModal] = useState(false)
  const [timeframesToShow, setTimeframesToShow] = useState(false)

  const toggleTimeframesModal = (timeframes: TSFixMe): void => {
    setTimeframesToShow(timeframes)
    setOpenTimeframesModal(true)
  }

  return (
    <>
      <TableContainer overflow>
        <Table marginBottom>
          <Thead>
            <Tr>
              {canWrite(FEATURES.SEASON_EVENT, login.accessToken.policies) && <Th />}
              <Th>
                <FormattedMessage id="dictionary.name" defaultMessage="Name" />
              </Th>
              <Th>
                <FormattedMessage id="dictionary.timeframes" defaultMessage="Timeframes" />
              </Th>
              <Th>
                <FormattedMessage id="dictionary.segments" defaultMessage="Segments" />
              </Th>
              <Th>
                <FormattedMessage id="dictionary.company" defaultMessage="Company" />
              </Th>
              <Th>
                <FormattedMessage id="seasonEvents.list.type" defaultMessage="Season" />
              </Th>
              <Th>
                <FormattedMessage id="dictionary.status" defaultMessage="Status" />
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {seasonEvents.map((seasonEvent): ReactElement => {
              return (
                <Tr key={seasonEvent.id}>
                  {canWrite(FEATURES.SEASON_EVENT, login.accessToken.policies) && (
                    <Td>
                      <SeasonEventsActions seasonEvent={seasonEvent} />
                    </Td>
                  )}
                  <Td>{seasonEvent.name}</Td>
                  <Td>
                    {seasonEvent.activePeriods.length === 1 ? (
                      <Timeframe>
                        <div>
                          <FormattedDate
                            intl={intl}
                            value={seasonEvent.activePeriods[0].startsAt}
                            month="2-digit"
                            day="2-digit"
                            year="numeric"
                          />
                          <SecondaryInfo>
                            <FormattedTimeByDate intl={intl} date={seasonEvent.activePeriods[0].startsAt} />
                          </SecondaryInfo>
                        </div>
                        <ArrowRightIcon />
                        <div>
                          <FormattedDate
                            intl={intl}
                            value={seasonEvent.activePeriods[0].endsAt}
                            month="2-digit"
                            day="2-digit"
                            year="numeric"
                          />
                          <SecondaryInfo>
                            <FormattedTimeByDate intl={intl} date={seasonEvent.activePeriods[0].endsAt} />
                          </SecondaryInfo>
                        </div>
                      </Timeframe>
                    ) : (
                      <StyledLink onClick={(): TSFixMe => toggleTimeframesModal(seasonEvent.activePeriods)}>
                        {seasonEvent.activePeriods.length}
                      </StyledLink>
                    )}
                  </Td>
                  <Td>
                    {seasonEvent.segments.length > 0 ? (
                      <Dropdown toggle={<StyledLink>{seasonEvent.segments.length}</StyledLink>} noPadding>
                        <List.Container>
                          {seasonEvent.segments.map(({ code, id }: TSFixMe): TSFixMe => {
                            return <List.Item key={id}>{code}</List.Item>
                          })}
                        </List.Container>
                      </Dropdown>
                    ) : (
                      0
                    )}
                  </Td>
                  <Td>{seasonEvent.company.name}</Td>
                  <Td>
                    {seasonTypeMessages[seasonEvent.type]
                      ? intl.formatMessage(seasonTypeMessages[seasonEvent.type])
                      : ''}
                  </Td>
                  <Td>
                    <SeasonEventStatus seasonEvent={seasonEvent} />
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>

      {isOpenTimeframesModal && (
        <TimeframesModal timeframes={timeframesToShow} closeModal={(): TSFixMe => setOpenTimeframesModal(false)} />
      )}
    </>
  )
}
